if (!customElements.get('product-talk-to-a-rep')) {
	customElements.define('product-talk-to-a-rep', class ProductTalkToARep extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.collapsed = this.getAttribute('expanded') === 'false';
			this.toggleElement = this.querySelector('.product-talk-to-a-rep-toggle');
			this.onToggle = this.onToggle.bind(this);
			this.toggleElement.addEventListener('click', this.onToggle);
		}

		onToggle(event) {
			event.preventDefault();
			this.handleToggle();
		}

		collapse() {
			this.setAttribute('expanded', 'false');
			this.toggleElement.setAttribute('aria-expanded', 'false');
			this.collapsed = true;
		}

		expand() {
			console.log("Expand called! (talk to a rep)");
			this.setAttribute('expanded', 'true');
			this.toggleElement.setAttribute('aria-expanded', 'true');
			this.collapsed = false;
			this.querySelector('input[name="contact[name]"]')?.focus();
		}

		handleToggle() {
			if (this.collapsed) {
				this.expand();
			} else {
				this.collapse();
			}
		}
	});
}
